import { DeflectionSettingsSchema } from "@redotech/redo-dispute-settings-common/deflection-settings";
import * as z from "zod";

// Save the RESOLVE deflection config as a unit, written to
// settings.disputes.deflection. Cleared fields arrive null.
export const updateDeflectionSettings = {
  name: "updateDeflectionSettings" as const,
  input: z.object({ settings: DeflectionSettingsSchema }),
  output: z.object({ success: z.boolean() }),
};
